import { CompassCardUI } from '@scale/compass-ui/types';
import {
  ContributorScreeningsAdapterCardShared,
  type ContributorScreeningsAdapterSchemaType,
  type ContributorScreeningsContext,
  type ContributorScreeningsSearchMode,
  CONTRIBUTOR_SCREENINGS_ADAPTER,
} from '@scale/genai-compass-shared/cards/contributor_screenings_adapter';
import { faUserCheck } from '@fortawesome/pro-solid-svg-icons';
import ContributorScreeningsAdapterCardComponent from './ContributorScreeningsAdapterCardComponent';

const defaultContext: ContributorScreeningsContext = {
  cardType: CONTRIBUTOR_SCREENINGS_ADAPTER,
  searchMode: 'Search' as ContributorScreeningsSearchMode,
  query: '',
  shouldUseElastic: true,
};

export const ContributorScreeningsAdapterCardInfo: CompassCardUI<ContributorScreeningsAdapterSchemaType> =
  {
    ...ContributorScreeningsAdapterCardShared,
    title: 'Contributors Screening',
    icon: 'people',
    toolTip: 'Screening for Contributor data (for Direct to Contributor projects)',
    defaultContext,
    legacyComponent: ContributorScreeningsAdapterCardComponent,
    button: {
      title: 'Screenings',
      icon: faUserCheck,
    },
  };
